import { useState, useEffect, Fragment } from 'react';
import { useTranslation } from 'react-i18next';


import { useStore } from '../../../../hook-store/store';
// import { createTokenForTools } from '../../../../utils/bucket/object-for-tools';
import { 
  getMetadataFromMetaList,
  getParsedMetadataFromObjectMeta,
 } from '../../../../utils/bucket/object-metadata-util';
import { 
  isAudioMimeType, 
  isVideoMimeType,
} from '../../../../utils/bucket/bucket-object-util';
import { mimeTypes } from '../../../../utils/file/mime-type';

import { 
    watakuraPageLink,
} from '../../../../App';

import { marks } from '../../../../utils/marks';

import classes from './FileActions.module.css'
// import * as bucketObjectUtils from '../utils/bucket-object-util';


function OpenInGroupTalk(props) {

  const {
    setClickedActionInfoHandler,
    setClickedObjectKeyHandler,
    object,
    parsedMeta,
    // tokenForToolsHandler,
    // isLoading,
  } = props;

  // console.log('ToolsLink.js-props', props, object.Key);
    const [t] = useTranslation('translation');


  const [store, dispatch] = useStore();
  // console.log('store-BucketObjects.js', store);
  const { bucketName } = store.bucketObjectStore;
  const { 
    allObjectsMetaList,
  } = store.objectMetadataStore;
  const { gLoading } = store.uiStore;

//   const [showForImageModal, setShowForImageModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);


  useEffect(() => {
    if (gLoading) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  },[gLoading]);


  // console.log(parsedMeta)
  let initialKey = '';

  if (parsedMeta?.initialKey) {
    initialKey = parsedMeta.initialKey;
  }

  // let isPresentationFile = false;

  // //// user's file case
  // const objectMetadata = getMetadataFromMetaList(object.Key, allObjectsMetaList);

  // if (objectMetadata && objectMetadata.parsedMetadata.isPresentationFile) {
  //   isPresentationFile = true;
  // }

  // //// share file case
  // if (object.objectMeta) {
  //   const parsedMeta = getParsedMetadataFromObjectMeta(object.objectMeta);

  //   if (parsedMeta && parsedMeta.isPresentationFile && 
  //       parsedMeta.shareInfo && parsedMeta.shareInfo.ownerId !== localStorage.getItem('userId')
  //   ) {
  //     isPresentationFile = true;
  //   }
  //   // console.log('object parsedMeta', parsedMeta);
  // }


  const paramKeyData = {
    bucket: bucketName,
    key: encodeURIComponent(object.Key),
    initialKey: encodeURIComponent(initialKey),
    mimeType: object.mimeType ? object.mimeType : '',
    userId: localStorage.getItem('userId'),
    openApp: 'groupTalk',
    size: object.Size,
    expire: Date.now() + 86400*1000,  // 24h 
  };


    //   const openEditLinkModalHandler = (openApp) => {
    //     setClickedObjectKeyHandler('');
    //     dispatch('SET_SHOWEDITLINKMODAL', true);
    //     dispatch('SET_EDITLINKMODALDATA', {
    //       key: object.Key,
    //       openApp: openApp,
    //       mimeType: object.mimeType ? object.mimeType : '',
    //     });
    //   };


    let openInGroupTalkBody

    openInGroupTalkBody = (
        <>
          <button className={classes.objectActionListItem}
            // style={{ paddingLeft: "1rem" }}
            disabled={isLoading}
            name="open-in-group-talk"
            onClick={(event) => {
            if (!isLoading) {
                setClickedActionInfoHandler(event, object.Key);
                setClickedObjectKeyHandler('');
            }
            }}
          >
            <a 
              // href={`${dreamInpaniterLink}/?key=${object.Key}&mimeType=${object.mimeType}&tokenForCasTGT=${localStorage.getItem('tokenForCasTGT')}&TGTexp=${localStorage.getItem('TGTexp')}`}
              href={`${watakuraPageLink}/group-talk-page?keyData=${JSON.stringify(paramKeyData)}`}
              target="_blank" rel="noreferrer noopener"
              style={{fontWeight: 'normal', color:"inherit", textDecoration:"none"}}
            >
              {marks.usersMark}{' '}
              {t('fileAction.27', 'Share file in Group Talk')}
              {' '}{marks.externalLinkMark}
            </a>
        </button>
      </>
    );


  return (
    <Fragment>
      {openInGroupTalkBody}
    </Fragment>
  );
}

export default OpenInGroupTalk;